enum GivexApiServer {
  Sandbox = 1,
  Beta = 2,
  ProductionUs = 3,
  ProductionCa = 4,
  ProductionPt = 5,
}

export { GivexApiServer };
